import { render, staticRenderFns } from "./DeleteClient.vue?vue&type=template&id=56005844&"
import script from "./DeleteClient.vue?vue&type=script&lang=ts&"
export * from "./DeleteClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports